import React, { useRef, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import clsx from "clsx";

import YouTube from "react-youtube";
import ReactTwitchEmbedVideo from "react-twitch-embed-video";

import styles from "./ContentCreatorMain.module.scss";
import { useTranslation } from "react-i18next";

export default function ContentCreatorMain(props) {
  const { youTubePlayList, twitchChannel } = props;  
  const { t } = useTranslation();

  const playerSettings = {
    width: 680
  };

  const sectionTitle = t('CF Content Creator');

  const ytOpts = {
    height: "100%",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      listType:'playlist',
      list: youTubePlayList,
      autoplay: 0
    }
  };

  const twOpts = {
    width: "100%",
    height: "100%",
    autoplay: false
  };

  const _onReady = event => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  };

  return (
    <Grid container justify="center" classes={{ root: styles.container }} spacing={2}>
      <Hidden smDown>
        <Grid item xs={12} classes={{ root: styles.heading }}>
          <h3>{sectionTitle}</h3>
        </Grid>
      </Hidden>
      <Hidden mdUp>
        <Grid
          item
          xs={12}
          classes={{ root: clsx(styles.heading, styles.mobile) }}
        >
          <h3>{sectionTitle}</h3>
        </Grid>
      </Hidden>
      {youTubePlayList &&
      <Grid item xs={12} md={6}>
        <div className={styles.player_outer}>
          <div className={styles.player_inner}>
            <YouTube list={youTubePlayList} opts={ytOpts} onReady={_onReady} />
          </div>
        </div>
      </Grid>
      }
      {twitchChannel && 
      <Grid item xs={12} md={6}>
        <div className={styles.player_outer}>
          <div className={styles.player_inner}>
            <ReactTwitchEmbedVideo
              channel={twitchChannel}
              height={twOpts.height}
              width={twOpts.width}
              autoplay={false}
              layout="video"
              muted
            />
          </div>
        </div>
      </Grid>
      }
    </Grid>
  );
}
